import { render, staticRenderFns } from "./AssetsBoard.vue?vue&type=template&id=51711c40&scoped=true&"
import script from "./AssetsBoard.vue?vue&type=script&lang=js&"
export * from "./AssetsBoard.vue?vue&type=script&lang=js&"
import style0 from "./AssetsBoard.vue?vue&type=style&index=0&id=51711c40&scoped=true&lang=css&"
import style1 from "./AssetsBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51711c40",
  null
  
)

export default component.exports